import { DependencyContainer, injectable } from "@launchtray/tsyringe-async";
import { Event } from "event-system";
import { BundleResourcesPackage } from "../../../../resources/BundleResourcesPackage";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";
import { FontResourcesPackage } from "../../common/resources/FontResourcesPackage";
import { MusicResourcePackageWrapper } from "../../common/resources/MusicResourcePackageWrapper";
import { SoundsResourcePackageWrapper } from "../../common/resources/SoundsResourcePackageWrapper";
import { GameResourcePackage } from "../../game/resources/GameResourcePackage";
import { NewsResourcePackage } from "../../game/resources/NewsResourcePackage";
import { IInitializer } from "./IInitializer";

@injectable()
export class ResourcesInitializer implements IInitializer {
    private readonly context: DependencyContainer;
    private readonly packagesToPreload: Map<new () => BundleResourcesPackage, BundleResourcesPackage>;
    private readonly packagesAmount: number;
    private loadedPackages: number;
    private readonly progressPerPackage: number;
    public readonly onInitializationProgress: Event<number>;

    public constructor(context: DependencyContainer) {
        this.context = context;
        this.onInitializationProgress = new Event<number>();
        this.packagesToPreload = new Map<new () => BundleResourcesPackage, BundleResourcesPackage>([
            [FontResourcesPackage, new FontResourcesPackage()],
            [CommonResourcesPackage, new CommonResourcesPackage()],
            [GameResourcePackage, new GameResourcePackage()],
            [SoundsResourcePackageWrapper, new SoundsResourcePackageWrapper()],
            [MusicResourcePackageWrapper, new MusicResourcePackageWrapper()],
            [NewsResourcePackage, new NewsResourcePackage()]
        ]);
        this.packagesAmount = this.packagesToPreload.size;
        this.loadedPackages = 0;
        this.progressPerPackage = 1.0 / this.packagesAmount;
    }

    public async start(): Promise<void> {
        await this.preloadPackages();
    }

    private async preloadPackages(): Promise<void> {
        for (const keyValuePair of this.packagesToPreload) {
            const pkgType = keyValuePair[0];
            const pkg = keyValuePair[1];
            pkg.onLoadingProgress.add(this.handleResourcesLoadingProgress, this);
            await pkg.load();
            pkg.onLoadingProgress.remove(this.handleResourcesLoadingProgress, this);
            this.loadedPackages++;
            this.context.registerInstance(pkgType, pkg);
        }
    }

    private handleResourcesLoadingProgress(packageProgress: number): void {
        this.onInitializationProgress.emit(this.loadedPackages / this.packagesAmount + this.progressPerPackage * packageProgress);
    }
}
